import { render, staticRenderFns } from "./FactModal.vue?vue&type=template&id=828f5ad0&"
import script from "./FactModal.vue?vue&type=script&lang=js&"
export * from "./FactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports